let loadedSets = {} as Record<string, Record<string, () => Promise<string>>>;

const getSetImportFn = (set: string) => {
	switch (set) {
		case 'base':
			return () => import('./base');
		case 'express':
			return () => import('./express');
		case 'flag':
			return () => import('./flag');
		default:
			return;
	}
};

const loadSet = async (set: string) => {
	const setImportFn = getSetImportFn(set);
	if (!setImportFn) {
		const resOfSets = await import('./rest');
		loadedSets = { ...loadedSets, ...resOfSets.default };
	} else {
		const loadedSet = await setImportFn();
		loadedSets[set] = loadedSet.default;
	}
};

export const getIcon = async (set: string, name: string) => {
	if (!loadedSets[set]) {
		await loadSet(set);
	}
	return await loadedSets[set][name]?.();
};
